module.exports = __webpack_public_path__ + "img/lemon-left-2.51def710.png";